const OP_SETTINGS = {
  PROCESSES_SHOW_NETTO_PRICE: 'processes_show_netto_price',
  PROCESSES_SHOW_BRUTTO_PRICE: 'processes_show_brutto_price',
  PROCESSES_ENABLED: 'search_processes_enabled',
};

export default OP_SETTINGS;
